import { render, staticRenderFns } from "./TopAppBarDrawerMember.vue?vue&type=template&id=3b05b278&scoped=true&"
import script from "./TopAppBarDrawerMember.vue?vue&type=script&lang=js&"
export * from "./TopAppBarDrawerMember.vue?vue&type=script&lang=js&"
import style0 from "./TopAppBarDrawerMember.vue?vue&type=style&index=0&id=3b05b278&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b05b278",
  null
  
)

export default component.exports